import React, { useContext, useRef } from 'react'
import classNames from 'classnames'
import { FullBlockLoader, CircleLoader, GridItem, Button } from '@deal/components'
import Review from '#src/components/Reviews/StarReviewWidget'
import { ExpertFooterUserReviewsComponent } from '#src/generated/graphql'
import { IdentityContext } from '#src/containers/Identity'
import SidebarAwareGrid from '../SidebarAwareGrid'
import styles from './styles.css'
import { Link } from 'react-router-dom'
import { generateReferAFriendUrl } from '#src/services/referrals'
import { AnalyticsContext } from '#src/containers/Analytics'
import useOnScreenCallback from '#src/hooks/useOnScreenCallback'

interface ExpertFooterProps {
  businessUserId: string
  className?: string
  businessUserName?: string | null
  hideReview?: boolean
  entryPoint: Tracking.EntryPoint
  centered?: boolean
}

const ExpertFooter: React.SFC<ExpertFooterProps> = ({
  hideReview,
  className,
  businessUserName,
  businessUserId,
  entryPoint,
  centered
}) => {
  const analytics = useContext(AnalyticsContext)
  const { myself } = useContext(IdentityContext)
  const shareModuleRef = useRef(null)

  // Fire this function once when the shareRefModule first enters viewport
  useOnScreenCallback(shareModuleRef, () => {
    analytics &&
      myself &&
      analytics.events.referralPageEntryPointViewed({
        entry_point: entryPoint
      })
  })

  if (!myself) {
    return null
  }
  return (
    <div className={classNames(styles.footer, className)}>
      <SidebarAwareGrid>
        <GridItem col={2}>
          <div className={classNames(styles.container, { [styles.centered]: centered })}>
            <div ref={shareModuleRef} className={styles.block}>
              <div className={styles.blockTitle}>Give 10% off, get 10% off </div>
              <div className={styles.blockContent}>
                Share your unique referral link with friends! They’ll get expert advice and
                handpicked recommendations plus 10% off their first purchase (up to $100 off). When
                they buy, you’ll get 10% your next purchase.
              </div>
              <Link to={generateReferAFriendUrl({ source: entryPoint, expert: businessUserId })}>
                <Button>Start sharing</Button>
              </Link>
            </div>

            {!hideReview && (
              <ExpertFooterUserReviewsComponent
                variables={{
                  userId: myself.user.id,
                  expertId: businessUserId
                }}
              >
                {({ data, loading }) => {
                  if (loading) {
                    return <FullBlockLoader loader={CircleLoader} />
                  } else if (data && data.user) {
                    const matchingExpertReview = data.user.consumerExpertReviewConnection.edges.find(
                      expertReviewEdge => expertReviewEdge.node.expert.id === businessUserId
                    )

                    if (!matchingExpertReview) {
                      return (
                        <>
                          <div className={styles.division} />
                          <div className={styles.block}>
                            <div className={styles.blockTitle}>
                              How's it going with{' '}
                              <span className={styles.name}>{businessUserName}</span>?
                            </div>
                            <div className={styles.blockContent}>
                              A quick rating below helps us continue to improve. All feedback about
                              your expert is appreciated!
                            </div>
                            <div className={centered ? styles.reviewsCentered : ''}>
                              <Review
                                expertId={businessUserId}
                                entryPoint={entryPoint}
                                largeIcons
                                invertedIcons
                              />
                            </div>
                          </div>
                        </>
                      )
                    }
                  }

                  return null
                }}
              </ExpertFooterUserReviewsComponent>
            )}
          </div>
        </GridItem>
      </SidebarAwareGrid>
    </div>
  )
}

export default ExpertFooter
